module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [(_vm.showProgressBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToProgress', _vm.orderDetail)
      }
    }
  }, [_vm._v("进展查询")]) : _vm._e(), _vm._v(" "), (_vm.showDownloadContractBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('downloadOrderText', _vm.orderDetail)
      }
    }
  }, [_vm._v("下载合同")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34031b06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/components/GcOrderListButtonsBase.vue
// module id = 1595
// module chunks = 8